import { Link } from "react-router-dom";

export function Arrow({ className = "", ...props }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      className={className}
      {...props}
    >
      <path d="M4 12h15M13 5l7 7-7 7" />
    </svg>
  );
}
export function Container({ children, className = "" }) {
  return (
    <div
      className={`sn-mx-auto sn-w-full sn-max-w-site sn-px-5 sm:sn-px-8 lg:sn-px-12 ${className}`}
    >
      {children}
    </div>
  );
}
export function Eyebrow({ children, light = false }) {
  return (
    <p
      className={`sn-mb-4 sn-text-[11px] sn-font-bold sn-uppercase sn-tracking-[0.18em] ${light ? "sn-text-sage" : "sn-text-leaf"}`}
    >
      {children}
    </p>
  );
}
export function SectionHeading({ eyebrow, children, light = false, id }) {
  return (
    <div>
      <Eyebrow light={light}>{eyebrow}</Eyebrow>
      <h2
        id={id}
        className={`sn-section-title sn-font-display ${light ? "sn-text-white" : "sn-text-forest"}`}
      >
        {children}
      </h2>
    </div>
  );
}
export function ButtonLink({
  to,
  children,
  variant = "primary",
  className = "",
}) {
  const variants = {
    primary: "sn-bg-forest sn-text-white hover:sn-bg-leaf",
    secondary:
      "sn-bg-transparent sn-text-forest sn-border sn-border-forest/30 hover:sn-bg-sage",
    light: "sn-bg-cream sn-text-forest hover:sn-bg-white",
  };
  return (
    <Link
      to={to}
      className={`sn-inline-flex sn-min-h-[48px] sn-items-center sn-justify-center sn-gap-4 sn-rounded sn-px-6 sn-py-3 sn-text-sm sn-font-semibold sn-transition ${variants[variant]} ${className}`}
    >
      {children}
      <Arrow />
    </Link>
  );
}
